import React from 'react';
import { ExternalLink, Building2 } from 'lucide-react';
import { Button } from './ui/button';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from './ui/dropdown-menu';

const BROKERS = [
  {
    key: 'zoomex',
    name: 'Zoomex',
    tagline: 'Crypto Futures',
    url: 'https://www.zoomex.com/en/',
    color: 'text-orange-400',
  },
  {
    key: 'ibkr',
    name: 'Interactive Brokers',
    tagline: 'Actions · Forex · Indices',
    url: 'https://www.clientportal.gdcdyn.interactivebrokers.com/portal',
    color: 'text-blue-400',
  },
];

/**
 * Dropdown menu that lets the user jump to their broker in a new tab.
 * Displayed in the Journal (History) header.
 */
export default function BrokerMenu({ label = 'Ouvrir chez un broker', className = '', variant = 'outline' }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} className={`border-primary/50 ${className}`} data-testid="open-broker-menu">
          <Building2 className="w-4 h-4 mr-2" />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 bg-card border-white/10">
        <DropdownMenuLabel className="text-xs uppercase tracking-widest text-muted-foreground">
          Brokers
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {BROKERS.map((b) => (
          <DropdownMenuItem
            key={b.key}
            onClick={() => window.open(b.url, '_blank', 'noopener,noreferrer')}
            className="cursor-pointer py-3"
            data-testid={`broker-item-${b.key}`}
          >
            <div className="flex-1">
              <div className={`font-semibold ${b.color}`}>{b.name}</div>
              <div className="text-[11px] text-muted-foreground">{b.tagline}</div>
            </div>
            <ExternalLink className="w-3.5 h-3.5 text-muted-foreground" />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
